module.exports = __webpack_public_path__ + "img/logo.5b1cdf85.svg";